/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { PropTypes as MicromagPropTypes } from '@micromag/core';

const StoryLinksContext = React.createContext(null);

export const useStoryLinks = () => {
    const { links } = useContext(StoryLinksContext);
    return links;
};

export const useStoryByPath = (path) => {
    const links = useStoryLinks();
    const link = links.find((it) => it.url === path) || null;
    return link !== null ? link.story : null;
};

const propTypes = {
    children: PropTypes.node.isRequired,
    links: MicromagPropTypes.storyLinks,
};

const defaultProps = {
    links: null,
};

export const StoryLinksProvider = ({ links: initialLinks, children }) => {
    const [links, setLinks] = useState(initialLinks || []);
    const value = useMemo(() => ({ links, setLinks }), [links, setLinks]);
    return <StoryLinksContext.Provider value={value}>{children}</StoryLinksContext.Provider>;
};

StoryLinksProvider.propTypes = propTypes;
StoryLinksProvider.defaultProps = defaultProps;

export default StoryLinksContext;
